import { theme } from '../../../../theme';
import { MenuListStyles } from '../styles';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const OptionStyled = (base, state) => ({
  ...base,
  padding: '7px 1.5rem',
  cursor: 'pointer',
  backgroundColor: state.isFocused ? theme.colors.white : theme.colors.white,
  '&:hover': {
    backgroundColor: theme.colors.surfaceBottom
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const GroupStyles = (base) => ({
  ...base,
  backgroundColor: theme.colors.white,
  padding: '14px 0',
  margin: 0,
  position: 'relative',
  '&:after': {
    content: "''",
    position: 'absolute',
    bottom: 0,
    left: '1.5rem',
    right: 0,
    height: 0,
    borderBottom: `1px solid ${theme.colors.line}`
  },
  '& > div:first-of-type': {
    padding: '0 1.5rem',
    color: theme.colors.secondary,
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px'
  },
  '&:last-child': {
    '&:after': {
      display: 'none'
    }
  }
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const MenuListStylesNew = (base) => ({
  ...MenuListStyles(base),
  '& > div': {
    lineHeight: '2.307rem',
    color: theme.colors.textPrimary,
    backgroundColor: theme.colors.white,
    hoverStyle: {
      backgroundColor: theme.colors.white
    }
  }
});
